<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
        @change="handleTableChange"
      >
        <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" class='custom-filter-dropdown'>
          <a-input
            v-ant-ref="c => searchInput = c"
            :placeholder="`Search ${column.title}`"
            :value="selectedKeys[0]"
            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
            @pressEnter="() => handleFilterSearch(selectedKeys, confirm)"
            style="width: 188px; margin-bottom: 8px; display: block;"
          />
          <a-button
            type='primary'
            @click="() => handleFilterSearch(selectedKeys, confirm)"
            icon="search"
            size="small"
            style="width: 90px; margin-right: 8px"
          >Search</a-button>
          <a-button
            @click="() => handleResetFilterSearch(clearFilters)"
            size="small"
            style="width: 90px"
          >Reset</a-button>
        </div>
        <a-icon slot="filterIcon" slot-scope="filtered" type='search' :style="{ color: filtered ? '#108ee9' : undefined }" />
        <template slot="created_by" slot-scope="created_by" v-if="created_by !== null">
          <span class="text-wrap">{{created_by.first_name }} {{ created_by.last_name}}</span>
        </template>
        <template slot="phone" slot-scope="created_by" v-if="created_by !== null">
          <span class="text-wrap">{{created_by.phone }}</span>
        </template>
        <template slot="created_on" slot-scope="created_on">
          <span class="text-wrap">{{formatDate(created_on)}}</span>
        </template>
        <template slot="status" slot-scope="status">
<!--          <span class="text-wrap">{{status}}</span>-->
          <a-tag :color="status === 'Open'? 'red': (status === 'In progress' ? 'green' : '' )">{{ status }}</a-tag>
        </template>
        <template slot="updated_on" slot-scope="updated_on">
          <span class="text-wrap">{{formatDate(updated_on)}}</span>
        </template>
        <template slot="action" slot-scope="record">
          <div class="text-nowrap">
            <a-tooltip
              placement="top"
              title="Update request"
            >
            <a href="javascript:" class="btn btn-sm btn-light btn-with-addon mr-2" @click="showEditModal(record)">
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              Update
            </a>
            </a-tooltip>

<!--            <a-tooltip
              placement="top"
              title="Delete request"
            >
            <a href="javascript:" class="btn btn-sm btn-danger btn-with-addon" @click="handleDelete(record)">
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete
            </a>
            </a-tooltip>-->
          </div>
        </template>
      </a-table>
    </div>

    <!-- <edit-school-class ref="editClass" @edited="handleEdited" /> -->
    <edit-support-request @onEditedSupportRequest="handleAfteredit"></edit-support-request>
  </div>
</template>

<script>
import EditSupportRequest from '@/components/support/requests/edit'
import moment from 'moment'

const columns = [
  { title: 'Req ID', sorter: true, width: '6%', dataIndex: 'request_id', scopedSlots: { customRender: 'request_id' } },
  { title: 'Subject', className: 'text-left text-gray-6 text-wrap', width: '30%', dataIndex: 'subject', scopedSlots: { customRender: 'subject' } },
  {
    title: 'Raised by',
    className: 'text-left text-gray-6 text-wrap',
    dataIndex: 'created_by',
    scopedSlots: {
      customRender: 'created_by',
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
    },
  },
  {
    title: 'Phone',
    className: 'text-left text-gray-6 text-wrap',
    dataIndex: 'created_by',
    scopedSlots: {
      customRender: 'phone',
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
    },
  },
  { title: 'Created on', width: '10%', sorter: true, dataIndex: 'created_at', scopedSlots: { customRender: 'created_on' } },
  {
    title: 'Priority',
    width: '7%',
    dataIndex: 'priority',
    scopedSlots: {
      customRender: 'priority',
    },
    filters: [{
      text: 'Low',
      value: 'Low',
    }, {
      text: 'Medium',
      value: 'Medium',
    }, {
      text: 'High',
      value: 'High',
    }, {
      text: 'Urgent',
      value: 'Urgent',
    },
    ],
    // onFilter: (value, record) => record.priority.indexOf(value) === 0,
  },
  {
    title: 'Status',
    width: '8%',
    dataIndex: 'status',
    scopedSlots: {
      customRender: 'status',
    },
    filters: [{
      text: 'Open',
      value: 'Open',
    }, {
      text: 'In progress',
      value: 'In progress',
    }, {
      text: 'Resolved',
      value: 'Resolved',
    }, {
      text: 'Closed',
      value: 'Closed',
    }, {
      text: 'Escalated',
      value: 'Escalated',
    }, {
      text: 'On hold',
      value: 'On hold',
    },
    ],
    // onFilter: (value, record) => record.status.indexOf(value) === 0,
  },
  { title: 'Updated on', width: '10%', sorter: true, dataIndex: 'updated_at', scopedSlots: { customRender: 'updated_on' } },
  { title: 'Actions', className: 'text-right', scopedSlots: { customRender: 'action' } },
]
// const fakedata = [
//   { id: 1, name: 'Eletronics', description: 'Category for electronics items' },
//   { id: 2, name: 'Fashion', description: 'Category for Fashion items' },
//   { id: 3, name: 'Furniture', description: 'Category for Furniture items' }
// ]
// const exposedEvents = { OnSubmit: 'onsubmit', OnEdit: 'onedit', OnDelete: 'ondelete' }

export default {
  name: 'RequestsTable',
  components: {
    EditSupportRequest,
    /* InwardTransaction,
    OutwardTransaction, */
  },
  props: {
    select: Boolean,
    loading: Boolean,
    rolesetting: { type: Object },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
      showeditform: false,
      datatoedit: {},
      searchRaisedBy: '',

    }
  },
  /* mounted: function () {
    this.fetchdata()
  }, */
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    /* fetchdata() {
      let api = '/api/inventory/product/stock/all'
      this.data.length = 0
      this.$http.get(api)
        .then((resp) => {
          this.data = resp.data.data
        })
        .catch(err => {
          console.error(err)
        })
    }, */
    handleTableChange: function (pagination, filters, sorter) {
      /* // let sortColumn = sorter.field === 'name' ? 'first_name' : sorter.field
      console.log(filters)
      // Start: Filter logics
      if (filters !== undefined) {
        console.log('InsideCheck::: ', filters)
        // Status column filter
        if (filters.status !== undefined && filters.status.length > 0) {
          console.log(filters.status.length)
        }
        // Priority column filter
        if (filters.priority !== undefined && filters.priority.length > 0) {
          console.log(filters.priority.length)
        }
      }
      // End: Filter logics */

      this.$emit('updateTable', { 'filters': filters, 'sorter': sorter })
      // let sortColumn = sorter.field === 'name' ? 'first_name' : sorter.field
      // this.$emit('updateTable', [sortColumn, sorter.order])
    },
    handleFilterSearch(selectedKeys, confirm) {
      // This will invoke handleTableChange() as this is also an custom filter
      confirm()
      /* this.searchRaisedBy = selectedKeys[0]
      this.$emit('updateTable', { 'searchRaisedBy': this.searchRaisedBy })
      console.log(this.searchRaisedBy) */
    },
    handleResetFilterSearch (clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    formatDate(date) {
      return moment(date).format('DD-MMM-YYYY h:mm A')
    },
    handleAfteredit() {
      this.$emit('updateTable')
    },
    showEditModal(record) {
      this.$eventBus.$emit('openEditSupportRequestForm', record)
    },
    closeEditform() {
      this.showeditform = false
    },
    handleDelete(record) {
      this.$confirm({
        title: 'Are you sure to delete this record?',
        content: 'Clicking yes will delete this request.',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/support_request/' + record.id)
            .then((resp) => {
              // this.$emit('updateTable')
              if (resp.status === 200) {
                this.$emit('updateTable') // Reload the table
                this.$nprogress.done()

                this.$notification['success']({
                  message: 'Deleted Successfully!',
                  description: 'The request has been deleted.',
                })
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description: 'There appears to be an error while submitting data. Please try again later.',
                })
              }
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>

<style>

</style>
